/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { Jubjub, JubjubInterface } from "../../contracts/Jubjub";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pollId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_pollAddr",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.PubKey",
        name: "_pubKey",
        type: "tuple",
      },
    ],
    name: "DeployPoll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ISignUpGatekeeper",
        name: "_signUpGatekeeper",
        type: "address",
      },
      {
        indexed: false,
        internalType: "contract IInitialVoiceCreditProxy",
        name: "_topupCredit",
        type: "address",
      },
    ],
    name: "Init",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pollId",
        type: "uint256",
      },
    ],
    name: "MergeMaciStateAq",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_pollId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "MergeMaciStateAqSubRoots",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_messageRoot",
        type: "uint256",
      },
    ],
    name: "MergeMessageAq",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "MergeMessageAqSubRoots",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.Message",
        name: "_message",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.PubKey",
        name: "_encPubKey",
        type: "tuple",
      },
    ],
    name: "PublishMessage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "_stateIndex",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct Jubjub.PubKey",
        name: "_userPubKey",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_voiceCreditBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_timestamp",
        type: "uint256",
      },
    ],
    name: "SignUp",
    type: "event",
  },
  {
    inputs: [],
    name: "blankMessageLeafHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "blankStateLeafHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "calculateCurrentMessageBatchIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "coordinatorPubKey",
    outputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "y",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "coordinatorPubKeyHash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentBallotCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentMessageCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentSbCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentStateCommitment",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_left",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_right",
        type: "uint256",
      },
    ],
    name: "hash",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        internalType: "struct Jubjub.Message",
        name: "_message",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_encPubKey",
        type: "tuple",
      },
    ],
    name: "hashMessageLeaf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "x",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "y",
                type: "uint256",
              },
            ],
            internalType: "struct Jubjub.PubKey",
            name: "pubKey",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "voiceCreditBalance",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "timestamp",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.StateLeaf",
        name: "_stateLeaf",
        type: "tuple",
      },
    ],
    name: "hashStateLeaf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stateTreeDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_messageTreeDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stateTreeSubDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_messageTreeSubDepth",
        type: "uint256",
      },
      {
        internalType: "uint256[]",
        name: "_emptyBallotRoots",
        type: "uint256[]",
      },
      {
        internalType: "contract ISignUpGatekeeper",
        name: "_signUpGatekeeper",
        type: "address",
      },
      {
        internalType: "contract IInitialVoiceCreditProxy",
        name: "_voiceCreditProxy",
        type: "address",
      },
      {
        internalType: "contract AccQueue",
        name: "_stateAq",
        type: "address",
      },
      {
        internalType: "contract AccQueue",
        name: "_messageAq",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialised",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mergeMessageAq",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "mergeMessageAqSubRoots",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "mergeStateAq",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_numSrQueueOps",
        type: "uint256",
      },
    ],
    name: "mergeStateAqSubRoots",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "messageAq",
    outputs: [
      {
        internalType: "contract AccQueue",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "messageTreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "messageTreeSubDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "numBatchesProcessed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numMessages",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numPolls",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "numSignUps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "openSignUpPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pollResults",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "polls",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_newStateCommitment",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_newSbCommitment",
        type: "uint256",
      },
      {
        internalType: "uint256[8]",
        name: "_proof",
        type: "uint256[8]",
      },
    ],
    name: "processMessages",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        internalType: "struct Jubjub.Message",
        name: "_message",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_encPubKey",
        type: "tuple",
      },
    ],
    name: "publishMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "msgType",
            type: "uint256",
          },
          {
            internalType: "uint256[10]",
            name: "data",
            type: "uint256[10]",
          },
        ],
        internalType: "struct Jubjub.Message[]",
        name: "_messages",
        type: "tuple[]",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey[]",
        name: "_encPubKeys",
        type: "tuple[]",
      },
    ],
    name: "publishMessageBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_voteOptionTreeDepth",
        type: "uint256",
      },
    ],
    name: "resetBallotCommitment",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract VkRegistry",
        name: "_vkRegistry",
        type: "address",
      },
    ],
    name: "setVkRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_pubKey",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "_signUpGatekeeperData",
        type: "bytes",
      },
      {
        internalType: "bytes",
        name: "_initialVoiceCreditProxyData",
        type: "bytes",
      },
    ],
    name: "signUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "signUpGatekeeper",
    outputs: [
      {
        internalType: "contract ISignUpGatekeeper",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "signUpTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "signUpsOpen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_voteOptionTreeDepth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "x",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "y",
            type: "uint256",
          },
        ],
        internalType: "struct Jubjub.PubKey",
        name: "_coordinatorPubKey",
        type: "tuple",
      },
    ],
    name: "startVoting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stateAq",
    outputs: [
      {
        internalType: "contract AccQueue",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "stateLeafTimeStamps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stateTreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stateTreeSubDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vkRegistry",
    outputs: [
      {
        internalType: "contract VkRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voiceCreditProxy",
    outputs: [
      {
        internalType: "contract IInitialVoiceCreditProxy",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteDeadline",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteDurationSeconds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "voteOptionTreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "0x60806040523480156200001157600080fd5b506200001c62000134565b7f0ef71f46e11a513c599eed9dd03576c33439bcfb1cee155316f90541e41649ba14620000a15760405162461bcd60e51b815260206004820152602860248201527f4d4143493a20424c414e4b5f53544154455f4c4541465f4841534820697320696044820152671b98dbdc9c9958dd60c21b60648201526084015b60405180910390fd5b620000ab62000194565b7f1dee9f497aa52e2ad4b049b789afb5056fbee5a0e3f1083a92d93cb3a5a70fb4146200012e5760405162461bcd60e51b815260206004820152602a60248201527f4d4143493a20424c414e4b5f4d4553534147455f4c4541465f48415348206973604482015269081a5b98dbdc9c9958dd60b21b606482015260840162000098565b620005e5565b604080518082018252600080516020620043b38339815191528152600080516020620043d383398151915260208083019190915282516060810184528281526000918101829052928301819052916200018d816200025a565b9250505090565b60408051610140810182527f12817f4161f2f5ded33f26c55735a77e80e4f8975483c8c2704745128417f711815260006020808301829052828401829052606083018290526080830182905260a0830182905260c0830182905260e083018290526101008301829052610120830182905283518085018552600080516020620043b38339815191528152600080516020620043d38339815191528183015284518086019095526001855290840183905290926200025281836200030f565b935050505090565b60006200026662000532565b82515181528251602090810151818301528301518160026020020152604083810151606083015251631efdc45960e11b815273__$56e03346d0918fb20a2db08690fd2c2075$__90633dfb88b290620002c49084906004016200056e565b602060405180830381865af4158015620002e2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190620003089190620005a1565b9392505050565b60006200031b62000550565b6020848101805151835280518201519183019190915280516040908101519083015280516060908101519083015251608090810151908201526200035e62000550565b6020858101805160a0908101518452815160c0015184840152815160e0015160408086019190915282516101000151606086015291516101200151608085015281519081018252875181529051639cfced9760e01b815273__$e63b1c9f9b66f613a0dd27ec595fdb417f$__92639cfced9792919082019084908490620003ea908990600401620005bb565b602060405180830381865af415801562000408573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906200042e9190620005a1565b815260200173__$e63b1c9f9b66f613a0dd27ec595fdb417f$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$e63b1c9f9b66f613a0dd27ec595fdb417f$__92639cfced97929190820190849084906113b690899060040161390c565b602060405180830381865af41580156113d3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906113f7919061365e565b815260200173__$e63b1c9f9b66f613a0dd27ec595fdb417f$__639cfced97866040518263ffffffff1660e01b8152600401611433919061390c565b602060405180830381865af4158015611450573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611474919061365e565b81526020018760000151815260200187602001518152506040518263ffffffff1660e01b81526004016114a7919061390c565b602060405180830381865af41580156114c4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114e8919061365e565b925050505b92915050565b6114fb612d7b565b60865460ff16156115435760405162461bcd60e51b815260206004820152601260248201527114d251d3955414d7d393d517d0d313d4d15160721b60448201526064016108bc565b606a6115506001836138df565b60058110611560576115606138f6565b0154607781905560408051606081018252607554815260208101929092526000828201525163bea140b360e01b815273__$8f0718d15a58b4353249f9bf6422c5f00e$__9163bea140b3916115b8919060040161393d565b602060405180830381865af41580156115d5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115f9919061365e565b60785550565b611607612d7b565b60865460ff16156116575760405162461bcd60e51b815260206004820152601a60248201527922a92927a92fa9a4a3a72aa829afa0a62922a0a22cafa7a822a760311b60448201526064016108bc565b6086805460ff19166001179055565b61166e612d7b565b6116786000612dda565b565b8260005b818160ff1610156116f5576116e386868360ff168181106116a1576116a16138f6565b905061016002018036038101906116b89190613965565b85858460ff168181106116cd576116cd6138f6565b9050604002018036038101906104039190613982565b806116ed8161399e565b91505061167e565b505050505050565b600080604051806101400160405280600080516020613d09833981519152815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815250905060006040518060400160405280600080516020613ce98339815191528152602001600080516020613d49833981519152815250905060006040518060400160405280600181526020018481525090506117b881836112e1565b935050505090565b60006117ca612ea4565b82515181528251602090810151818301528301518160026020020152604083810151606083015251631efdc45960e11b815273__$56e03346d0918fb20a2db08690fd2c2075$__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__$c6850fb4e0ee9ead61bcd830cbea02ad6d$__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__$c6850fb4e0ee9ead61bcd830cbea02ad6d$__92635bb9399592612c2392600401918252602082015260400190565b602060405180830381865af4158015612c40573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c64919061365e565b60735560006074556070546040517f76b880f3c8580b5bb05765c3b2160a2860692566e7f8cce8c58d23e77f3130c291612ca19130908890613c7a565b60405180910390a1600080516020613d698339815191528183604051612cc892919061383c565b60405180910390a1505050505050565b612ce0612d7b565b6001600160a01b038116612d455760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016108bc565b612d4e81612dda565b50565b612d59612d7b565b608080546001600160a01b0319166001600160a01b0392909216919091179055565b33612d8461201e565b6001600160a01b0316146116785760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016108bc565b603380546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600054610100900460ff16612e535760405162461bcd60e51b81526004016108bc90613c9d565b611678600054610100900460ff16612e7d5760405162461bcd60e51b81526004016108bc90613c9d565b61167833612dda565b6040518060a001604052806005906020820280368337509192915050565b60405180608001604052806004906020820280368337509192915050565b60405180604001604052806002906020820280368337509192915050565b600060208284031215612ef257600080fd5b5035919050565b634e487b7160e01b600052604160045260246000fd5b604080519081016001600160401b0381118282101715612f3157612f31612ef9565b60405290565b60405160a081016001600160401b0381118282101715612f3157612f31612ef9565b604051601f8201601f191681016001600160401b0381118282101715612f8157612f81612ef9565b604052919050565b600060408284031215612f9b57600080fd5b612fa3612f0f565b9050813581526020820135602082015292915050565b600082601f830112612fca57600080fd5b81356001600160401b03811115612fe357612fe3612ef9565b612ff6601f8201601f1916602001612f59565b81815284602083860101111561300b57600080fd5b816020850160208301376000918101602001919091529392505050565b60008060006080848603121561303d57600080fd5b6130478585612f89565b925060408401356001600160401b038082111561306357600080fd5b61306f87838801612fb9565b9350606086013591508082111561308557600080fd5b5061309286828701612fb9565b9150509250925092565b60006101608083850312156130b057600080fd5b6130b8612f0f565b915082358252602084603f8501126130cf57600080fd5b60405161014081016001600160401b03811182821017156130f2576130f2612ef9565b60405291840191808684111561310757600080fd5b8286015b84811015613122578035825290830190830161310b565b5050908301525092915050565b6000806101a0838503121561314357600080fd5b61314d848461309c565b915061315d846101608501612f89565b90509250929050565b6000806000806040858703121561317c57600080fd5b84356001600160401b038082111561319357600080fd5b818701915087601f8301126131a757600080fd5b8135818111156131b657600080fd5b886020610160830285010111156131cc57600080fd5b6020928301965094509086013590808211156131e757600080fd5b818701915087601f8301126131fb57600080fd5b81358181111561320a57600080fd5b8860208260061b850101111561321f57600080fd5b95989497505060200194505050565b60006080828403121561324057600080fd5b604051606081016001600160401b038111828210171561326257613262612ef9565b60405261326f8484612f89565b815260408301356020820152606083013560408201528091505092915050565b60006001600160401b038211156132a8576132a8612ef9565b5060051b60200190565b6001600160a01b0381168114612d4e57600080fd5b80356132d2816132b2565b919050565b60008060008060008060008060006101208a8c0312156132f657600080fd5b893598506020808b0135985060408b0135975060608b0135965060808b01356001600160401b0381111561332957600080fd5b8b01601f81018d1361333a57600080fd5b803561334d6133488261328f565b612f59565b81815260059190911b8201830190838101908f83111561336c57600080fd5b928401925b8284101561338a57833582529284019290840190613371565b809950505050505061339e60a08b016132c7565b93506133ac60c08b016132c7565b92506133ba60e08b016132c7565b91506133c96101008b016132c7565b90509295985092959850929598565b600080604083850312156133eb57600080fd5b50508035926020909101359150565b6000806020838503121561340d57600080fd5b82356001600160401b038082111561342457600080fd5b818501915085601f83011261343857600080fd5b81358181111561344757600080fd5b8660208260051b850101111561345c57600080fd5b60209290920196919550909350505050565b6000815180845260005b8181101561349457602081850181015186830182015201613478565b818111156134a6576000602083870101525b50601f01601f19169290920160200192915050565b6000602080830181845280855180835260408601915060408160051b870101925083870160005b8281101561351057603f198886030184526134fe85835161346e565b945092850192908501906001016134e2565b5092979650505050505050565b600080600061014080858703121561353457600080fd5b84359350602080860135935086605f87011261354f57600080fd5b60405161010081016001600160401b038111828210171561357257613572612ef9565b60405291860191808884111561358757600080fd5b604088015b848110156135a3578035825290830190830161358c565b50508093505050509250925092565b6000806000608084860312156135c757600080fd5b83359250602084013591506135df8560408601612f89565b90509250925092565b6000602082840312156135fa57600080fd5b8135611867816132b2565b60006020828403121561361757600080fd5b8151801515811461186757600080fd5b6020808252601f908201527f4552524f525f4d4553534147455f41515f414c52454144595f4d455247454400604082015260600190565b60006020828403121561367057600080fd5b5051919050565b6020808252601d908201527f4552524f525f53544154455f41515f414c52454144595f4d4552474544000000604082015260600190565b602080825260159082015274135050d24e881b9bdd081a5b9a5d1a585b1a5cd959605a1b604082015260600190565b634e487b7160e01b600052601160045260246000fd5b600181815b8085111561372e578160001904821115613714576137146136dd565b8085161561372157918102915b93841c93908002906136f8565b509250929050565b600082613745575060016114ed565b81613752575060006114ed565b816001811461376857600281146137725761378e565b60019150506114ed565b60ff841115613783576137836136dd565b50506001821b6114ed565b5060208310610133831016604e8410600b84101617156137b1575081810a6114ed565b6137bb83836136f3565b80600019048211156137cf576137cf6136dd565b029392505050565b60006118678383613736565b6001600160a01b03831681526040602082018190526000906122759083018461346e565b80518252602090810151910152565b84815260a0810161382a6020830186613807565b60608201939093526080015292915050565b825181526020808401516101a08301919081840160005b600a81101561387057825182529183019190830190600101613853565b50505050611867610160830184613807565b634e487b7160e01b600052601260045260246000fd5b6000826138a7576138a7613882565b500690565b6000826138bb576138bb613882565b500490565b60008160001904831182151516156138da576138da6136dd565b500290565b6000828210156138f1576138f16136dd565b500390565b634e487b7160e01b600052603260045260246000fd5b60a08101818360005b6005811015613934578151835260209283019290910190600101613915565b50505092915050565b60608101818360005b6003811015613934578151835260209283019290910190600101613946565b6000610160828403121561397857600080fd5b611867838361309c565b60006040828403121561399457600080fd5b6118678383612f89565b600060ff821660ff8114156139b5576139b56136dd565b60010192915050565b60808101818360005b60048110156139345781518352602092830192909101906001016139c7565b6020808252601290820152710929c869ea4a48a86a840a6aa84888aa0a8960731b604082015260600190565b60408101818360005b6002811015613934578151835260209283019290910190600101613a1b565b600060408284031215613a4c57600080fd5b613a54612f0f565b9050815181526020820151602082015292915050565b600082601f830112613a7b57600080fd5b604080519081016001600160401b0381118282101715613a9d57613a9d612ef9565b8060405250806040840185811115613ab457600080fd5b845b81811015613ace578051835260209283019201613ab6565b509195945050505050565b600060808284031215613aeb57600080fd5b613af3612f0f565b9050613aff8383613a6a565b8152613b0e8360408401613a6a565b602082015292915050565b60006020808385031215613b2c57600080fd5b82516001600160401b0380821115613b4357600080fd5b908401906101e08287031215613b5857600080fd5b613b60612f37565b613b6a8784613a3a565b81526040613b7a88828601613ad9565b85830152613b8b8860c08601613ad9565b81830152613b9d886101408601613ad9565b60608301526101c084015183811115613bb557600080fd5b80850194505087601f850112613bca57600080fd5b83519250613bda6133488461328f565b83815260069390931b84018501928581019089851115613bf957600080fd5b948601945b84861015613c1f57613c108a87613a3a565b82529482019490860190613bfe565b60808401525090979650505050505050565b6000600019821415613c4557613c456136dd565b5060010190565b634e487b7160e01b600052602160045260246000fd5b60008219821115613c7557613c756136dd565b500190565b8381526001600160a01b0383166020820152608081016122756040830184613807565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b60608201526080019056fe171e826ad4a870fd925e0bf0e87884e70e080879c2205ef10114f28a3b6f6dd712817f4161f2f5ded33f26c55735a77e80e4f8975483c8c2704745128417f71130644e72e131a029b85045b68181585d2833e84879b9709143e1f593f00000012bd407d897fbbca9f88adfd2d15252e69de8c1564eb4d3d27162e259172f1a1de2067f06dd7b8159b21a5490f8663f6bb031d9b35ed6d298b5489674cb9cda4ba2646970667358221220cc66c04d1d0fef90174f5ddc9fa31265ed24c1ec1a50f469ebafaed591bffb2764736f6c634300080a0033171e826ad4a870fd925e0bf0e87884e70e080879c2205ef10114f28a3b6f6dd72bd407d897fbbca9f88adfd2d15252e69de8c1564eb4d3d27162e259172f1a1d";

type JubjubConstructorParams =
  | [linkLibraryAddresses: JubjubLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: JubjubConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Jubjub__factory extends ContractFactory {
  constructor(...args: JubjubConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Jubjub__factory.linkBytecode(linkLibraryAddresses), signer);
    }
  }

  static linkBytecode(linkLibraryAddresses: JubjubLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$56e03346d0918fb20a2db08690fd2c2075\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT5.sol:PoseidonT5"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$e63b1c9f9b66f613a0dd27ec595fdb417f\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT6.sol:PoseidonT6"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$8f0718d15a58b4353249f9bf6422c5f00e\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT4.sol:PoseidonT4"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$c6850fb4e0ee9ead61bcd830cbea02ad6d\\$__", "g"),
      linkLibraryAddresses["contracts/poseidon/PoseidonT3.sol:PoseidonT3"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Jubjub> {
    return super.deploy(overrides || {}) as Promise<Jubjub>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): Jubjub {
    return super.attach(address) as Jubjub;
  }
  override connect(signer: Signer): Jubjub__factory {
    return super.connect(signer) as Jubjub__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): JubjubInterface {
    return new utils.Interface(_abi) as JubjubInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Jubjub {
    return new Contract(address, _abi, signerOrProvider) as Jubjub;
  }
}

export interface JubjubLibraryAddresses {
  ["contracts/poseidon/PoseidonT5.sol:PoseidonT5"]: string;
  ["contracts/poseidon/PoseidonT6.sol:PoseidonT6"]: string;
  ["contracts/poseidon/PoseidonT4.sol:PoseidonT4"]: string;
  ["contracts/poseidon/PoseidonT3.sol:PoseidonT3"]: string;
}
